<template>
  <div id="app">
    <!-- <button @click="testApi">123123</button> -->
    <keep-alive :include="keepAliveNames">
      <router-view></router-view>
    </keep-alive>
     <div
      v-if="FullScreenScanner"
      class="home-float-btn"
      @click="goHome"
    >
      <img style="width: 20px;" src="https://file.findmacau.com/xcx/back-index.png" alt="">
      <span>{{ $t("home.title") }}</span>
    </div>
  </div>
</template>

<script>
import {youmengId,youmengUrl} from './config/env'
import home from '@/api/home'
export default {
  data () {
    return {
      transitionName: 'fold-left',
      keepAliveNames: [
        'findmacau',
        'merchantJoin',
        'home',
        'shopping',
        'citythings',
        'my'
      ]
    }
  },

  // vue监听路由对象$route的方法
  watch: {
    // watch $route 决定使用哪种过渡
    $route(to, from) {
      
      const routerType = to.params.routerType;
     

      if (routerType === "push") {
        this.keepAliveNames.push(to.name);
        // this.transitionName = "fold-left";
      } else {
        this.keepAliveNames.pop();
        // this.transitionName = "fold-right";
      }
    }
  },
  mounted () {
    const script = document.createElement('script')
//    script.src = 'https://s95.cnzz.com/z_stat.php?id='+youmengId+'&web_id='+youmengId;// uat
//    script.src = 'https://s22.cnzz.com/z_stat.php?id='+youmengId+'&web_id='+youmengId; // 正式环境
    script.src =youmengUrl + '?id=' + youmengId + '&web_id=' + youmengId;
    script.language = 'JavaScript'
    document.body.appendChild(script)

    this.audioAutoPlay('audio');
    // 自动播放音乐效果，解决微信自动播放问题
    document.addEventListener('touchstart',this.audioAutoPlay,false);
    document.addEventListener('WeixinJSBridgeReady', this.audioAutoPlay,false);
    let oAudio = document.querySelector("#audio");
    oAudio.onended = function () {//播放完毕，重新循环播放
        oAudio.load();
        oAudio.play();
    }
     const preventDefault = e => e.preventDefault();
    
    // 移动端手势
    document.addEventListener('gesturestart', preventDefault);
    document.addEventListener('gesturechange', preventDefault);
    
    // PC 端键盘
    document.addEventListener('keydown', e => {
      if ((e.ctrlKey || e.metaKey) && ['+', '-', '=', '0'].includes(e.key)) {
        e.preventDefault();
      }
    });
    
    // PC 端滚轮
    document.addEventListener('wheel', e => {
      if (e.ctrlKey || e.metaKey) e.preventDefault();
    }, { passive: false });
  },
  computed: {
  FullScreenScanner() {
    const path = this.$route.path

    return path.includes('FullScreenScanner') || path.includes('onsumer')|| path.includes('MineCouponList')
  }
},
  methods:{
    goHome() {
      if (this.$route.path !== '/home') {
        this.$router.push('/home')
      }
    },
    testApi(  ){
         home.testApi()
    },
    
       audioAutoPlay() {
          let audio = document.getElementById('audio');
          this.isOff = false;
          audio.play();
          document.removeEventListener('touchstart',this.audioAutoPlay);
       },
      
  },
  
  components: {
  },
  
}
</script>

<style lang="scss">
  	@import './style/common';
    .home-float-btn {
  position: fixed;
  right: 24px;
  bottom: 60px;
  z-index: 9999;

  width: 58px;
  height: 58px;
  border-radius: 50%;

  background: #FF8800;
  color: #fff;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  cursor: pointer;
  box-shadow: 0 5px 18px rgba(0, 0, 0, 0.2);

  transition: all 0.25s ease;
}

.home-float-btn i {
  font-size: 22px;
  margin-bottom: 2px;
}

.home-float-btn span {
  font-size: 11px;
}

.home-float-btn:hover {
  transform: translateY(-3px);
}

.home-float-btn:active {
  transform: scale(0.9);
}

/* 手机端 */
@media screen and (max-width: 768px) {
  .home-float-btn {
    right: 16px;
    bottom: 90px;
    width: 52px;
    height: 52px;
  }

  .home-float-btn i {
    font-size: 20px;
  }

  .home-float-btn span {
    font-size: 10px;
  }
}
    html {
  touch-action: manipulation; /* 禁止双击缩放 + 双指缩放 */
}
	#app {
  // display: flex;
  // width: 100%;
  // height: 100%;
  //   height: 100vh;
  // overflow-y: auto;
  // -webkit-overflow-scrolling: touch;
  // position: relative;

  // push页面时：新页面的进入动画
  .fold-left-enter-active {
    animation-name: fold-left-in;
    animation-duration: .4s;
  }
  // push页面时：老页面的退出动画
  .fold-left-leave-active {
    animation-name: fold-left-out;
    animation-duration: .4s;
  }
  // push页面时：新页面的进入动画
  @keyframes fold-left-in {
    0% {
      transform: translate(100%, 0);
      /* visibility: visible; */
    }
    100% {
      transform: translate(0, 0);
    }
  }
  // push页面时：老页面的退出动画
  @keyframes fold-left-out {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(-100%, 0);
      /* visibility: hidden; */
    }
  }

  // 后退页面时：即将展示的页面动画
  .fold-right-enter-active {
    animation-name: fold-right-in;
    animation-duration: .4s;
  }
  // 后退页面时：后退的页面执行的动画
  .fold-right-leave-active {
    animation-name: fold-right-out;
    animation-duration: .4s;
  }
  // 后退页面时：即将展示的页面动画
  @keyframes fold-right-in{
    0% {
      width: 100%;
      transform: translate(-100%, 0);
      /* visibility: visible; */
    }
    100% {
      width: 100%;
      transform: translate(0, 0);
    }
  }
  // 后退页面时：后退的页面执行的动画
  @keyframes fold-right-out  {
    0% {
      width: 100%;
      transform: translate(0, 0);
    }
    100% {
      width: 100%;
      transform: translate(100%, 0);
      /* visibility: hidden; */
    }
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?7178a456